import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PropertyGrid from '../Property/Grid';
import NoResults from '../NoResults/NoResults';

const Grid = ({ isDesktop, properties, filters }) => {
    // Rendered before the early returns: properties are only set on the client (Office
    // componentDidMount), so this is what the server-rendered page gets for title and meta
    const head = (
        <Helmet>
            <title>View All the HPP Properties | Hudson Pacific Properties</title>
            <meta name="description" property="og:description" content="Our office portfolio features ideally located, custom designed workspaces for innovators and those who support them." />
        </Helmet>
    );

    if (!properties) return head;
    if (properties.length === 0) return <React.Fragment>{head}<NoResults /></React.Fragment>;
    if (!isDesktop) return <Redirect to="/office/list" />;

    return (
        <div className="section grid-view">
            {head}
            <div className="container">
                <div className="columns is-multiline">
                    {properties.filter(property => property.showMarker).map((property, index) => {
                        return (
                            <div key={index}
                                className={`grid-item
                                    column
                                    is-12-mobile
                                    is-half-tablet
                                    is-one-third-desktop
                                    is-one-third-widescreen
                                    is-one-third-fullhd`}>
                                <PropertyGrid key={index} property={property} filters={filters} />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

Grid.propTypes = {
    isDesktop: PropTypes.bool.isRequired,
    properties: PropTypes.array,
    filters: PropTypes.object,
};

export default Grid;
